import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CustomDatePickerComponent } from './custom-date-picker.component';

@NgModule({
    declarations: [CustomDatePickerComponent],
    exports: [CustomDatePickerComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class CustomDatePickerModule {}
